// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Conversații',
  new_chat: 'Conversație nouă',
  note: {
    team: 'Conversațiile tuturor la {{restaurant}}: ale tale, ale echipei și ale restaurantului.',
    own: 'Conversațiile tale la {{restaurant}}.',
  },
  log: 'Toate solicitările din jurnalul Amigo',
  days: {
    today: 'Azi',
    yesterday: 'Ieri',
    earlier: 'Mai devreme',
  },
  who: {
    you: 'Tu',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Proprietar',
      staff: 'Personal',
      partner: 'Partener',
    },
  },
  status: {
    done: 'Finalizat',
    answered: 'Răspuns trimis',
    waiting: 'În așteptarea aprobării',
    partial: '{{applied}} din {{total}} aplicate',
    rejected: 'Respins',
    not_yet: 'Nu s-a putut face încă',
    failed: 'Eșuat',
  },
  none: {
    title: 'Încă nu există conversații pentru {{restaurant}}',
    text: 'Conversațiile începute aici rămân aici, ca să te poți întoarce la ele.',
  },
  loading: 'Se încarcă conversațiile…',
  loading_more: 'Se încarcă mai multe conversații…',
  load_failed: 'Conversațiile nu au putut fi încărcate.',
  retry: 'Încearcă din nou',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Răspuns nou:',
  new_answers_few: 'Răspunsuri noi:',
  new_answers_other: 'Răspunsuri noi:',
};
